import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: 'filter'
  })
  export class FilterPipe implements PipeTransform {
    transform(items: any[], searchTerm: string): any[] {
      if (!items || !searchTerm) {
        return items; // return original array if no search term is provided
      }
      searchTerm = searchTerm.toLowerCase(); // convert search term to lowercase for case insensitive search

      const datePatternFull = /^\d{4}-\d{2}-\d{2}$/; // yyyy-MM-dd
      const datePatternMonth = /^\d{4}-\d{2}$/; // yyyy-MM
      const datePatternYear = /^\d{4}$/; // yyyy
      const isDateSearch = datePatternFull.test(searchTerm) || datePatternMonth.test(searchTerm) || datePatternYear.test(searchTerm);

      return items.filter(item => {
        const itemDateStr = item.timeStamp ? new Date(item.timeStamp).toISOString().split('T')[0] : '';

        if (isDateSearch) {
          // Check if itemDateStr matches searchTerm exactly or as a starting substring
          return itemDateStr.startsWith(searchTerm);
        }
        // Check specific properties that you want to include in the search
        return (
          item.board?.assetTag?.toLowerCase().includes(searchTerm) ||
          item.board?.serialNumber?.toLowerCase().includes(searchTerm) ||
          (item.board?.location?.salesRep.firstName + ' ' + item.board?.location?.salesRep.lastName)
            .toLowerCase().includes(searchTerm) ||
          item.board?.installedGamePackage?.name?.toLowerCase().includes(searchTerm) ||
          item.cashInDiff.toString().includes(searchTerm) ||
          item.cashOutDiff.toString().includes(searchTerm) ||
          item.profit.toString().includes(searchTerm) ||
          item.coinInDiff.toString().includes(searchTerm) ||
          item.coinOutDiff.toString().includes(searchTerm) ||
          item.gamePlayedDiff.toString().includes(searchTerm) ||
          item.gameWonDiff.toString().includes(searchTerm) ||
          item.daysSincePrevRead.toString().includes(searchTerm)
        );
      });
    }
  }